"use client";

import { useQuery } from "@tanstack/react-query";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import { useEffect } from "react";

import { isServer } from "@/src/lib/runtime";

// Initialize PDF.js worker
if (!isServer) {
  GlobalWorkerOptions.workerSrc = "/pdfjs/pdf.worker.mjs";
}

export const PDF_QUERY_KEY = "pdf";

export function getPdfQueryKey(url: string) {
  return [PDF_QUERY_KEY, url] as const;
}

export async function fetchPdfDocument(url: string) {
  const documentLoader = getDocument(url);
  const document = await documentLoader.promise;

  return document;
}

export function usePdf(url: string) {
  return useQuery({
    queryKey: getPdfQueryKey(url),
    queryFn: () => fetchPdfDocument(url),
    enabled: !!url,
    refetchInterval: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });
}

export function usePdfWithCleanup(url: string) {
  const { data, isLoading, isError, error } = usePdf(url);

  useEffect(() => {
    return () => {
      data?.destroy();
    };
  }, [data]);

  return { data, isLoading, isError, error };
}
